import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderTitle } from '../../models/generic';
import { DataService } from '../../services/data.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-sair',
  templateUrl: './sair.component.html',
  styleUrls: ['./sair.component.scss']
})
export class SairComponent {
  constructor(private router: Router,
    private _activatedRoute: ActivatedRoute,
    private _dataService: DataService,
    public authService: AuthService) {
    const title = _activatedRoute.snapshot.routeConfig?.title as HeaderTitle;
    this._dataService.setHeaderTitle(title);
  }

  logout() {
    this.authService.logout();
  }

  logoutOld(): void {
    console.log('Saindo...');

    setTimeout(() => {
      this.router.navigate(['/autenticacao'], { replaceUrl: true });
    }, 1000);
  }
}
